module.exports = __webpack_public_path__ + "static/media/Barley_flour.7435967a.png";